import { InputContainer } from "../form/form.module";


export const AgentAssignComponents = ({
    transportAgents,
    onFormChange,
    selectedValue
}: any) => {

    return (
        <>

            <>
                <div className=" grid md:grid-cols-1 lg:grid-cols-1 gap-1">

                    <InputContainer
                        label="Transport Agent"
                        labelField="TransportAgentInfo.Name"
                        list={transportAgents}
                        onValueChange={(event: any, newValue: any) => {
                            onFormChange({
                                value: event.target.value,
                                field: 'AgentId',
                            });
                        }}
                        optionName="Choose Driver"
                        type="select"
                        value={selectedValue?.AgentId}
                        valueField="TransportAgentId"
                    />

                </div>
            </>


        </>
    );
};
